import { defineStore, acceptHMRUpdate } from 'pinia';
import { storeConfigWithoutPersist } from '@/shared/storeConfig';
import type { ForceRequestKycReasons } from '@/types/UserData';

const kycStore = () => {
  type KycSource = keyof Containment.Context | ForceRequestKycReasons;

  const kycId = ref<number>(0);
  const kycSource = ref<KycSource>('global');

  function $reset() {
    kycId.value = 0;
    kycSource.value = 'global';
  }

  return {
    $reset,
    kycId,
    kycSource,
  };
};

export const useKycStore = defineStore(
  'kyc',
  kycStore,
  storeConfigWithoutPersist,
);

// @ts-ignore
if (import.meta.hot) {
  // @ts-ignore
  import.meta.hot.accept(acceptHMRUpdate(useKycStore, import.meta.hot));
}
